(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-mobile-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('focusin', function(e){ if(e.target.matches('input, textarea, select')) document.body.classList.add('tmx-keyboard-open'); });
document.addEventListener('focusout', function(){ document.body.classList.remove('tmx-keyboard-open'); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmx-avocado-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tmx-avocado-collection')) {
    customElements.define('tmx-avocado-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.selectedSize = '';
        this.cards = Array.from(this.querySelectorAll('[data-card]')).map(element => ({element, variants: JSON.parse(element.querySelector('[data-variants]').textContent), order: Number(element.dataset.order)}));
        this.feel = this.querySelector('[data-feel]');
        this.sort = this.querySelector('[data-sort]');
        this.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => {this.selectedSize = button.dataset.size; this.update();}));
        this.feel.addEventListener('change', () => this.update());
        this.sort.addEventListener('change', () => this.update());
        this.querySelector('[data-reset]').addEventListener('click', () => {this.selectedSize = ''; this.feel.value = ''; this.sort.value = 'featured'; this.update();});
        this.querySelector('[data-controls]').hidden = false;
        this.update();
      }
      update() {
        let visible = 0;
        this.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.size === this.selectedSize)));
        this.cards.forEach(card => {
          const matching = card.variants.filter(variant => (!this.selectedSize || variant.size === this.selectedSize) && (!this.feel.value || variant.feel === this.feel.value));
          card.element.hidden = matching.length === 0;
          if (!matching.length) return;
          visible++;
          const available = matching.filter(variant => variant.available);
          const cheapest = (available.length ? available : matching).reduce((a, b) => a.price <= b.price ? a : b);
          card.currentPrice = cheapest.price;
          card.element.querySelector('[data-price]').textContent = cheapest.formatted;
          card.element.querySelector('[data-stock]').hidden = available.length > 0;
          const url = card.element.dataset.url + (this.selectedSize || this.feel.value ? '?variant=' + cheapest.id : '');
          card.element.querySelectorAll('[data-product-link]').forEach(link => link.setAttribute('href', url));
        });
        const ordered = [...this.cards].sort((a, b) => this.sort.value === 'asc' ? (a.currentPrice || 0) - (b.currentPrice || 0) : this.sort.value === 'desc' ? (b.currentPrice || 0) - (a.currentPrice || 0) : a.order - b.order);
        const grid = this.querySelector('[data-cards]');
        const help = grid.querySelector('.tav__help');
        ordered.forEach(card => grid.insertBefore(card.element, help));
        this.querySelector('[data-count]').textContent = this.dataset.countTemplate.replace('__COUNT__', visible);
        this.querySelector('[data-empty]').hidden = visible !== 0;
        this.querySelector('[data-pair]').hidden = this.selectedSize !== 'Split King';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
